import React, {Component} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import axios from "axios";
import '../spinner.css'

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    async componentDidMount() {
        const {businessId, priceId, appToken} = this.props;
        let result = await this.getStripeMember(businessId, priceId, appToken);
        if (result.data.isBillingPortal) {
            this.navigateToBillingPortal(result.data.url)
        } else {
            await this.redirectToCheckout(result.data.id, result.data.stripePublicKey, result.data.stripeConnectedAccountId);
        }
    }

    async getStripeMember(businessId, priceId, appToken) {
        let result;
        try {
            result = await axios.get(`/api/StripeMember`, {
                params: {
                    businessId,
                    priceId,
                    appToken: appToken,
                    returnUrl: window.location.href
                }
            });
        } catch (e) {
            console.error("error");
            this.setState({error: true});
        }
        return result;
    }

    async redirectToCheckout(sessionId, stripePublicKey, stripeAccountId) {
        const options = {};
        if(stripeAccountId){
            options.stripeAccount = stripeAccountId;
        }
        const stripe = await loadStripe(stripePublicKey, options);
        await stripe.redirectToCheckout({
            sessionId: sessionId,
        })
    }

    navigateToBillingPortal(url) {
        window.location.href = url;
    }
    
    render() {
        return (
            <div>
                {this.state.error && 
                    <div>Sorry, an error occured</div>
                }
                {!this.state.error &&
                    <div className="loader"/>
                }
            </div>
        );
    }
}
